import { SET_DATE_RANGE, RESET_DATE_RANGE } from "../actions/dateFilterActions";

const initialState = {
  startDate: null,
  endDate: null,
};

export default function dateFilterReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATE_RANGE:
      return {
        ...state,
        startDate: action.payload?.startDate ?? state.startDate,
        endDate: action.payload?.endDate ?? state.endDate,
      };
    case RESET_DATE_RANGE:
      return initialState;
    default:
      return state;
  }
}
